export enum CustomFieldTypeEnum {
  Integer = 'INTEGER',
  Text = 'STRING',
  Boolean = 'BOOLEAN',
  Decimal = 'FLOAT',
}

export type CustomField = {
  id: number;
  userPrompt: string;
  type: CustomFieldTypeEnum;
  position: number;
}
